// extracted by mini-css-extract-plugin
export default {"card":"MetricCard_card__FR7qa","icon":"MetricCard_icon__msbx1","heading":"MetricCard_heading__hbJL1","label":"MetricCard_label__62aLm","value":"MetricCard_value__1XdOo"};